 <template>
  <b-modal
    :id="modalId"
    ref="modal"
    :size="size"
    header-class="anchor-modal"
    :title="title"
    no-close-on-backdrop
    static
    scrollable
    hide-footer
  >
    <action-modal-wizard-header :showMaturityDate="showMaturityDate" ref="header" :loan="loan" />
    <form-wizard
      color="#3e88c9"
      title=""
      subtitle=""
      error-color="#a94442"
      ref="wizard"
      stepSize="xs"
      @on-complete="$emit('form-completed')"
      @keyup.enter.native="enterHandler"
      @on-change="onStepChange"
    >
      <slot></slot>

      <template slot="footer" slot-scope="props">
        <b-col class="text-center mt-3">
          <wizard-button
            v-if="props.activeTabIndex > 0"
            class="d-inline mr-3 previous-button"
            @click.native="props.prevTab()">
            <font-awesome-icon icon="chevron-left" />
              Previous
          </wizard-button>
          <wizard-button
            v-if="!props.isLastStep"
            class="d-inline mr-3 next-button"
            @click.native="props.nextTab()"
            :style="props.fillButtonStyle">
              Next
              <font-awesome-icon icon="chevron-right" />
          </wizard-button>
          <wizard-button
            v-if="props.isLastStep"
            class="d-inline mr-3 finish-button"
            @click.native="props.nextTab()"
            :style="props.fillButtonStyle"
          >
              <font-awesome-icon icon="check" />
              Done
          </wizard-button>
        </b-col>
      </template>
    </form-wizard>
  </b-modal>
</template>

<script>
import ActionModalWizardHeader from '@/components/my_deals/actions/ActionModalWizardHeader';
import { FormWizard, WizardButton } from 'vue-form-wizard';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft, faChevronRight, faCheck } from '@fortawesome/free-solid-svg-icons';


library.add(faChevronLeft, faChevronRight, faCheck);


export default {
  components: {
    ActionModalWizardHeader,
    FormWizard,
    WizardButton,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'xl',
    },
    showMaturityDate: {
      type: Boolean,
    },
    modalIdPrefix: String,
  },
  computed: {
    modalId() {
      return `${this.modalIdPrefix}action-wizard-modal`;
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onStepChange() {
      const modalBody = document.querySelector('.modal-body');
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    },
    enterHandler() {
      const wizard = this.$refs.wizard;
      if (!wizard || wizard.isLastStep) { return; }

      wizard.nextTab();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (this.modalId === modalId) {
        this.$emit('modal-hidden', bvEvent, modalId);
      }
    });

    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (this.modalId === modalId) {
        this.$nextTick(() => {
          const wizard = this.$refs.wizard;
          if (wizard) {
            wizard.reset();
          }
        });
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/ActionModalWizard.vue